module.exports = __webpack_public_path__ + "img/12_25.0945604a.png";